"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _constant2 = require("../CarrierLogo/constant");
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    carrier: _propTypes.default.shape({
      cabinClass: _propTypes.default.string,
      marketingCarrierName: _propTypes.default.string,
      marketingAirlineName: _propTypes.default.string,
      marketingFlightNumber: _propTypes.default.number,
      marketingCarrierCode: _propTypes.default.string,
      operatingCarrierName: _propTypes.default.string,
      operatingFlightNumber: _propTypes.default.number,
      operatingCarrierCode: _propTypes.default.string,
      carbonEmissionInKiloGrams: _propTypes.default.number
    }),
    carrierLogoSize: _propTypes.default.string,
    designator: _propTypes.default.shape({
      departureStation: _propTypes.default.string,
      arrivalStation: _propTypes.default.string,
      departureTime: _propTypes.default.string,
      arrivalTime: _propTypes.default.string
    }),
    duration: _propTypes.default.number,
    translation: _propTypes.default.shape({
      hour: _propTypes.default.string,
      day: _propTypes.default.string,
      economy: _propTypes.default.string,
      premium: _propTypes.default.string,
      business: _propTypes.default.string,
      first: _propTypes.default.string
    }),
    isMobile: _propTypes.default.bool,
    isBusFerry: _propTypes.default.bool,
    busFerryLabel: _propTypes.default.string,
    guest: _propTypes.default.number
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    customProperties: {},
    carrier: {},
    carrierLogoSize: _constant2.SIZES.SMALL,
    designator: {},
    translation: {},
    isMobile: false,
    isBusFerry: false
  }
};
exports.default = _default;